import $ from 'jquery';
import DataTable, { type Config } from 'datatables.net';

const transpose = (matrix: any[][]) => {
  return matrix[0].map((_, colIndex) => matrix.map((row) => row[colIndex]));
};

$(function () {
  const selectedIDs: string[] = [];
  const tables = $('.data-table-hook');
  if (tables.length > 0) {
    tables.each(function () {
      const table = $(this);
      const columnsSplitted: string[] = table.data('dtColumns').split(',');

      const options: Config = {
        stateSave: true,
        columns: columnsSplitted.map(function (column) {
          return {
            data: column,
            name: column,
            searchable: true,
            orderable: true,
          };
        }),
        createdRow: function (row, data) {
          if ('link' in data) {
            $(row).attr('link', data.link as string);
            $(row).addClass('pointer');
          }
        },
        columnDefs: [
          {
            targets: '_all',
            render: function (data, _type, _row, meta) {
              var columnName = meta.settings.aoColumns[meta.col].mData;
              if (data && columnName.endsWith('Link')) {
                if (typeof data === 'string') {
                  return "<a href='" + data + "'>" + data + '</a>';
                } else if (data.url) {
                  return "<a href='" + data.url + "' target='" + (data.target || '') + "'>" + data.content + '</a>';
                }
              }
              if (data && columnName.endsWith('ImageUrl')) {
                if (typeof data === 'string') {
                  return "<img src='" + data + "'/>";
                } else if (data.src) {
                  return "<img src='" + data.src + "' class='" + data.cssClass + "'/>";
                }
              }

              return data;
            },
          },
        ],
        select: {
          style: 'multi',
          selector: 'td:first-child',
        },
      };

      if (table.data('dtSelection') === 'True') {
        options.select = { style: 'multi' };
        options.columns!.unshift({
          data: 'selection',
          name: 'selection',
          defaultContent: '',
        });
        options.columnDefs!.unshift({
          orderable: false,
          className: 'select-checkbox',
          render: DataTable.render.select(),
          targets: 0,
        });
      } else {
        options.select = false;
      }

      if (table.data('dtResponsive') && table.data('dtResponsive') === 'True') {
        options.responsive = true;
      } else {
        options.responsive = false;
      }

      if (table.data('dtUrl')) {
        options.serverSide = true;
        options.ajax = table.data('dtUrl');
        options.processing = true;
      }
      if (table.data('dtPaging')) {
        options.lengthMenu = table.data('dtPaging').split(',');
        options.pageLength = Number(options.lengthMenu![0]);
      }

      if (table.data('dtOrdering') === 'True') {
        options.order = [[table.data('dtSortcolumn'), table.data('dtSortorder')]];
      } else {
        options.ordering = false;
      }

      if (table.data('dtGroupRowColumns')) {
        const columns: string[] = table.data('dtGroupRowColumns').split(',');
        options.drawCallback = function () {
          const api = this.api();
          const rows = api.rows({ page: 'current' }).nodes();
          let prevGroup: string | null = null;
          const columnsData = api.columns(columns.map((col) => `${col}:name`)).data();
          const transposedData = transpose(columnsData.toArray());
          transposedData.forEach(function (rowData, i) {
            const group = rowData.join(' - ');
            if (prevGroup !== group) {
              $(rows).eq(i).before(`<tr class="group"><td colspan="${columnsSplitted.length}">${group}</td></tr>`);

              prevGroup = group;
            }
          });
        };
      }

      var search = table.data('dtSearch');
      if (search) {
        options.search = {
          search: search,
        };
      }
      options.stateSaveCallback = function (settings, data) {
        try {
          var storage = settings.iStateDuration === -1 ? sessionStorage : localStorage;
          storage.setItem(
            'DataTables_' + settings.sInstance + '_' + location.pathname.replace(/\d+$/, ''),
            JSON.stringify(data)
          );
        } catch (e) {
          // ignored
        }
      };
      options.stateLoadCallback = function (settings) {
        try {
          const storage = settings.iStateDuration === -1 ? sessionStorage : localStorage;
          const item = storage.getItem(
            'DataTables_' + settings.sInstance + '_' + location.pathname.replace(/\d+$/, '')
          );
          const result = item ? JSON.parse(item) : {};
          if (result.search) {
            if (result.search.search !== search) {
              result.start = 0;
            }
            result.search.search = search;
          } else {
            result.search = {
              search: search,
            };
          }
          return result || {};
        } catch {
          // ignored
        }
        return {};
      };

      const tableInstance = table.DataTable(options);

      const selectionInput = table.data('dtSelectionInput');
      const selectionProperty = table.data('dtSelectionProperty');
      function handleSelection() {
        const selected = tableInstance.rows('.selected');
        if (selectionInput && selectionProperty) {
          const values = selected.data().map(function (data) {
            return data[selectionProperty];
          });
          $(selectionInput).val(values.join(','));
        }

        const selectedCount = selected.nodes().length;
        const totalCount = tableInstance.rows().nodes().length;

        if (selectedCount === totalCount) {
          $('.toggle-all').closest('tr').addClass('selected');
        } else {
          $('.toggle-all').closest('tr').removeClass('selected');
        }
      }

      tableInstance.on('select.dt deselect.dt', handleSelection);

      tableInstance.on('xhr.dt', (_event, _settings, json) => {
        // go to first page if there are records available but none are shown
        if (json.data && !json.data.length && json.recordsTotal && tableInstance.page() > 0) {
          tableInstance.page(0).draw(false);
        }
      });

      table.on('click', 'tbody > tr > td', function (event) {
        var self = $(this);
        var parent = self.parent();

        if (parent.hasClass('child')) {
          var parentRowIndex = Number(parent.data('dtRow'));
          parent = $(tableInstance.row(parentRowIndex).node());
        }

        if (self.hasClass('deleteLink')) {
          var id = self.text();

          if (!parent.hasClass('selected')) {
            parent.addClass('selected');
            selectedIDs.push(id);
          } else {
            parent.removeClass('selected');
            const index = selectedIDs.indexOf(id);
            if (index > -1) {
              selectedIDs.splice(index, 1);
            }
          }
          var fieldId = table.data('dtDeletefieldid');
          if (fieldId) {
            $(fieldId).val(selectedIDs);
          }

          return;
        }
        const link = parent.attr('link');
        const isResponsiveElement = self.hasClass('dtr-control') && table.hasClass('collapsed');
        const isSelectionColumn = tableInstance.column(self.index()).header().classList.contains('select-checkbox');
        if (link && !isResponsiveElement && !isSelectionColumn) {
          if (event.ctrlKey || event.shiftKey || event.metaKey) {
            event.preventDefault();
            window.open(link, '_blank');
          } else {
            window.location.href = link;
          }
        }
      });

      table.on('click', '.toggle-all', function () {
        $(this).closest('tr').toggleClass('selected');
        if ($(this).closest('tr').hasClass('selected')) {
          tableInstance.rows().select();
        } else {
          tableInstance.rows().deselect();
        }
      });
    });
  }
});
